<template>
  <div class="p-1">
    <Fieldset
      class="p-0"
    >
      <template #legend>
        <input
          id="enableday"
          type="checkbox"
          :checked="modelValue != null"
          class="mr-2"
          @change="toggleEnable"
        >
        <label for="enableday">{{ title }}</label>
      </template>

      <div v-if="modelValue != null">
        <div class="col-12 p-0">
          <label for="availabilityStartTime">{{ $t('entity.planning.from') }}</label>
          <Calendar
            id="availabilityStartTime"
            :model-value="formattedData.availabilityStartTime"
            :show-time="true"
            :time-only="true"
            class="m-2 max-w-4rem"
            @date-select="value => update('availabilityStartTime', value)"
          />
          <label for="availabilityEndTime">{{ $t('entity.planning.to') }}</label>
          <Calendar
            id="availabilityEndTime"
            :model-value="formattedData.availabilityEndTime"
            :show-time="true"
            :time-only="true"
            class="m-2 max-w-4rem"
            @date-select="value => update('availabilityEndTime', value)"
          />
        </div>
      </div>
    </Fieldset>
  </div>
</template>

<script>
import Fieldset from 'primevue/fieldset'
import Calendar from "primevue/calendar";
import moment from "moment";

const DEFAULT_DAY = {
  id: null,
  availabilityStartTime: '08:00:00',
  availabilityEndTime: '18:00:00',
}

export default {
  name: 'RoamingTeamDayPlanningForm',
  components: {Calendar, Fieldset },
  props: {
    title: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    formattedData(){
      return {
        id: this.modelValue.id,
        availabilityStartTime: moment(this.modelValue.availabilityStartTime, 'HH:mm:ss').toDate(),
        availabilityEndTime: moment(this.modelValue.availabilityEndTime, 'HH:mm:ss').toDate()
      }
    }
  },
  methods: {
    toggleEnable() {
      this.$emit('update:modelValue', this.modelValue ? null : DEFAULT_DAY)
    },

    update(field, value){
      let data = {...this.formattedData}
      data[field] = value
      data.availabilityStartTime = moment(data.availabilityStartTime).format('HH:mm:ss')
      data.availabilityEndTime = moment(data.availabilityEndTime).format('HH:mm:ss')
      this.$emit('update:modelValue', data)
    }
  }
}
</script>
